import { GET_PROMOCION, ADD_PROMOCION, MODIFY_PROMOCION, DELETE_PROMOCION, UPDATE_PROMOCION } from '../constants/action_types';

const initialState = {
    promocionList: [],
    isLoading: false
};

export function getDescr(value)
{
    const tipos = ['','General', 'Bienvenida', 'Teórica'];
    return tipos[value ? value : 0]
}


export default function (state = initialState, action) {

    switch (action.type) {
        case GET_PROMOCION:
            
            return {
                ...state, centroId: action.meta,
                isLoading: true
            };

        case GET_PROMOCION + "_SUCCESS":
            const newPromo = action.payload.data.map(p => {
                return {...p, tipoPromocionDescr: getDescr(p.iTipoPromocion)}
             })

            return {
                promocionList: newPromo, //action.payload.data,
                isLoading: false
            };

        case ADD_PROMOCION:
            
            const newArr = [...state.promocionList, action.payload]
            return {
                promocionList: newArr,
                isLoading: false
            };

        case MODIFY_PROMOCION:
            
            return {
                promocionList: state.promocionList.map((p) => {
                    if (p.id !== action.payload.id) 
                        return p;
                    else
                        return {...action.payload, tipoPromocionDescr: getDescr(action.payload.iTipoPromocion)};
                }),
                isLoading: false
            };

        case DELETE_PROMOCION:

            return {
                promocionList: state.promocionList.filter(p => p.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_PROMOCION + "_SUCCESS":

            return state;

        default:

            return state;
    }
}